
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const O3101 = lazy(() => import('../pages/o3-101/page'));
const Safety = lazy(() => import('../pages/safety/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const CookiePolicy = lazy(() => import('../pages/cookie-policy/page'));
const Disclaimer = lazy(() => import('../pages/disclaimer/page'));
const Termini = lazy(() => import('../pages/termini/page'));
const Products = lazy(() => import('../pages/prodotti/page'));
const OzonoSauna = lazy(() => import('../pages/prodotti/ozonosauna/page'));
const EcoLavatriceOzoneFusion = lazy(() => import('../pages/prodotti/eco-lavatrice-ozonefusion/page'));
const FreshZero = lazy(() => import('../pages/prodotti/freshzero/page'));
const O3Air = lazy(() => import('../pages/prodotti/o3-air/page'));
const AcquaFusion = lazy(() => import('../pages/prodotti/acquafusion/page'));
const MiniPurificatore = lazy(() => import('../pages/prodotti/mini-purificatore/page'));
const ConfrontaProdotti = lazy(() => import('../pages/confronta-prodotti/page'));
const Appuntamenti = lazy(() => import('../pages/appuntamenti/page'));
const AdminLeads = lazy(() => import('../pages/admin/leads/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/prodotti',
    element: <Products />,
  },
  {
    path: '/prodotti/ozonosauna',
    element: <OzonoSauna />,
  },
  {
    path: '/prodotti/eco-lavatrice-ozonefusion',
    element: <EcoLavatriceOzoneFusion />,
  },
  {
    path: '/prodotti/freshzero',
    element: <FreshZero />,
  },
  {
    path: '/prodotti/o3-air',
    element: <O3Air />,
  },
  {
    path: '/prodotti/acquafusion',
    element: <AcquaFusion />,
  },
  {
    path: '/prodotti/mini-purificatore',
    element: <MiniPurificatore />,
  },
  {
    path: '/confronta-prodotti',
    element: <ConfrontaProdotti />,
  },
  {
    path: '/appuntamenti',
    element: <Appuntamenti />,
  },
  {
    path: '/o3-101',
    element: <O3101 />,
  },
  {
    path: '/sicurezza',
    element: <Safety />,
  },
  {
    path: '/safety',
    element: <Safety />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicy />,
  },
  {
    path: '/disclaimer',
    element: <Disclaimer />,
  },
  {
    path: '/termini',
    element: <Termini />,
  },
  {
    path: '/admin/leads',
    element: <AdminLeads />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
